import CloseIcon from '@mui/icons-material/Close'
import { Link } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import styles from './PrivacyPolicy.module.scss'

export const PrivacyPolicy = (props) => {
  const { isOpen, closeModal } = props

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      maxWidth="sm"
      className={styles.styledDialog}
    >
      <DialogTitle className={styles.styledDialogTitle}>
        Target+ Seller Application Privacy Statement
        <IconButton onClick={closeModal} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div className={styles.styledSpacer} />
        <DialogContentText className={styles.styledDialogContentText}>
          At Target, we want you to know how we collect, use, share and protect
          information about you. This privacy policy applies to information
          collected as part of Target Plus’s seller process.{' '}
        </DialogContentText>
        <div className={styles.styledSpacer} />
        <DialogContentText
          className={styles.styledDialogContentText}
          fontWeight="bold"
        >
          What information is collected?
        </DialogContentText>
        <div className={styles.styledSpacer} />
        <DialogContentText className={styles.styledDialogContentText}>
          We collect information you provide directly, including:
        </DialogContentText>
        <ul>
          <li> Name </li>
          <li>Email address</li>
          <li>Company Name</li>
          <li>
            Company Information, e.g. description of assortment, operations,
            technology, capabilities
          </li>
        </ul>
        <DialogContentText className={styles.styledDialogContentText}>
          We may also automatically collect information about your use of the
          Target Plus Seller Application, including:
        </DialogContentText>{' '}
        <ul>
          <li> Utilization data, e.g. # of users </li>
          <li>
            Session data, e.g. date and time device entered, length of session
          </li>
          <li>Type of device, e.g. iPhone, Samsung tablet</li>
          <li>Browser data, e.g. browser version, IP address</li>
          <li>Device data, e.g. Device ID number, MAC address</li>
        </ul>
        <DialogContentText
          className={styles.styledDialogContentText}
          fontWeight="bold"
        >
          How is this information used?
        </DialogContentText>
        <div className={styles.styledSpacer} />
        <DialogContentText className={styles.styledDialogContentText}>
          Ways we use the information we collect include:
        </DialogContentText>
        <ul>
          <li>
            Responding to applications, e.g. sending information about Target
            Plus
          </li>
          <li>Internal operations, e.g. opportunities by category</li>
          <li>
            Legal compliance, e.g. assist law enforcement and respond to
            legal/regulatory inquiries
          </li>
        </ul>
        <DialogContentText
          className={styles.styledDialogContentText}
          fontWeight="bold"
        >
          How is this information shared?
        </DialogContentText>
        <div className={styles.styledSpacer} />
        <DialogContentText className={styles.styledDialogContentText}>
          The information we collect may be shared:
        </DialogContentText>
        <ul>
          <li>
            Within Target Corporation, which includes all Target subsidiaries
            and affiliates
          </li>
          <li>
            When we believe disclosure is appropriate to comply with the law; to
            apply applicable terms and conditions and other agreements; or to
            protect the rights, property or safety of our company, our guests or
            others
          </li>
        </ul>
        <DialogContentText
          className={styles.styledDialogContentText}
          fontWeight="bold"
        >
          Other web site analytics services
        </DialogContentText>
        <div className={styles.styledSpacer} />
        <DialogContentText className={styles.styledDialogContentText}>
          Analytics services such as Google Analytics provide services analyze
          information regarding visits to our websites and mobile applications.
          They use cookies, web beacons, and other tracking mechanisms to
          collect this information.
        </DialogContentText>
        <ul>
          <li>
            To learn more about Google’s privacy practices, click{' '}
            <Link
              className={styles.styledExternalPolicyLink}
              underline="none"
              href="https://policies.google.com/privacy"
              target="_blank"
              aria-label="Click here to view Google's privacy practices"
            >
              here
            </Link>
            . To access and use the Google Analytics Opt-out Browser Add-on,
            click{' '}
            <Link
              className={styles.styledExternalPolicyLink}
              underline="none"
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              aria-label="Click here to view Google Analytics Opt-out Browser Add-on"
            >
              here
            </Link>
            .
          </li>
        </ul>
        <DialogContentText className={styles.styledDialogContentText}>
          <b>How is this information protected?</b>
        </DialogContentText>
        <div className={styles.styledSpacer} />
        <DialogContentText className={styles.styledDialogContentText}>
          We maintain administrative, technical and physical safeguards to
          protect your information.
        </DialogContentText>
        <div className={styles.styledSpacer} />
        <DialogContentText className={styles.styledDialogContentText}>
          California Residents: For state-specific information, please see the
          California Business Privacy Notice at{' '}
          <Link
            className={styles.styledExternalPolicyLink}
            underline="none"
            href="https://corporate.target.com/about/contact-help#privacy"
            target="_blank"
            aria-label="Click here to view California Business Privacy Notice"
          >
            https://corporate.target.com/about/contact-help#privacy
          </Link>
          .
        </DialogContentText>
        <div className={styles.styledSpacer} />
        <DialogContentText className={styles.styledDialogContentText}>
          <b>How do you contact Target?</b>
        </DialogContentText>
        <ul>
          <li>
            Mail: Target HQ Locations, Target Executive Offices, P.O. Box 9350,
            Minneapolis, MN 55440
          </li>
          <li>Phone: 800-440-0680</li>
        </ul>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.styledCloseButton}
          variant="outlined"
          fullWidth
          size="large"
          onClick={closeModal}
          aria-label="close"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PrivacyPolicy
